exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.select-member-list{box-shadow:0 0 8px 0 rgba(0,0,0,.2)}.select-member-list .member-list-caption{font-family:Open Sans,sans-serif;font-weight:600;font-size:14px;color:#6d6e71;letter-spacing:0}.select-member-list .select-member-scroller{overflow-x:none;overflow-y:auto;height:250px;width:209px}.select-member-list .select-member-scroller .select-member-container{padding-left:15px;padding-top:10px}.select-member-list .select-member-scroller .select-member-container .members-search-box .members-search-input{background-color:#6d6e71;margin-bottom:10px;width:77%;padding-left:25px;background:url(" + require("../../../../assets/images/search-icon-grey.svg") + ") no-repeat 0;background-size:12px;background-position:5px;border:1px solid gray;border-radius:3px;padding-top:4px;padding-bottom:4px}.select-member-list .select-member-scroller .select-member-container .members-search-box input::placeholder{font-family:Open Sans,sans-serif;font-weight:400;font-size:10px;color:#8b8b8b;font-style:normal}.select-member-list .select-member-scroller .select-member-container .member-entry{margin-left:4px;height:33px}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/containers/PORContainer/EmailUserSelectionPopup/SelectMemberList/SelectMemberList.scss
// module id = 1757
// module chunks = 0